

































import { Vue, Component, Prop } from "@/shared/vuepack";
import { useUserStore } from "@/shared/store/user";
import { useHsaAccountStore } from "@/employer/store/hsabAccounts";

@Component({})
export default class Carousel extends Vue {
  @Prop()
  isPreviewMode: boolean;
  @Prop()
  banners: any[];

  currentIndex = 0;
  rotationMs = 5000;
  rotationTimer = null;
  isLoading = false;
  loadError = null;

  userStore = useUserStore();
  hsabAccountsStore = useHsaAccountStore();

  substituteVariables (originalString: string) {
    if (this.isPreviewMode) {
      return originalString;
    }

    return originalString.replace("%%WEXLINKURL%%", this.hsabAccountsStore.getWexSsoLink())
      .replace("%%USERNAME%%", this.userStore.user.firstName);
  }

  async mounted () {
    if (!this.isPreviewMode) {
      await this.hsabAccountsStore.getWexLink();
    }
  }

  created () {
    if (!this.isPreviewMode) {
      this.startAutoRotate();
    } else {
      this.currentIndex = 0;
    }
  }

  beforeDestroy () {
    if (this.rotationTimer) clearInterval(this.rotationTimer);
  }

  get slides () {
      return (this.banners || [])
          .slice()
          .sort(
              (a, b) =>
                  (a.carouselBannerNumber ?? 0) -
                  (b.carouselBannerNumber ?? 0)
          )
          .map(b => {
            const titleA = b.titleA || (this.isPreviewMode ? "Header" : "");
            const titleB = b.titleB || (this.isPreviewMode ? "Title" : "");
            const description = (b.description ?? b.copy ?? "")
                || (this.isPreviewMode ? "Description" : "");
            const linkText = (b.linkText ?? b.linkTitle ?? "")
                || (this.isPreviewMode ? "Link Text" : "");
            const linkUrl = b.linkUrl || (this.isPreviewMode ? "" : "");

            return {
              id: b.id,
              partnerId: b.partnerId,
              titleA,
              titleB,
              description,
              linkUrl,
              linkText,
              carouselBannerNumber: b.carouselBannerNumber ?? 0,
            };
          });
    }

    dotCount () {
      return this.isPreviewMode ? 4 : this.slides.length;
    }

    startAutoRotate () {
      if (this.rotationTimer) clearInterval(this.rotationTimer);
      if (this.isPreviewMode) return;

      if (this.slides.length > 1) {
        this.rotationTimer = setInterval(() => {
          const len = this.slides.length;
          if (!Array.isArray(this.slides) || len === 0) return;
          this.currentIndex = (this.currentIndex + 1) % len;
        }, this.rotationMs);
      }
    }

    onDotClick (index) {
      if (this.isPreviewMode) return;
      this.goToSlide(index);
    }

    goToSlide (index) {
      if (index < 0 || index >= this.slides.length) return;
      this.currentIndex = index;
    }

    goToLink (link) {
      if (!link) return;

      window.open(link, "_blank");
    }
}
